<!-- ===================== CLIENTES (filtros + rejilla de logos) ===================== -->
<section class="clients" id="clientes">
  <div class="clients-head">
    <span class="eyebrow">{{ 'clientes.eyebrow' | translate }}</span>
    <h1 class="section-title" [innerHTML]="'clientes.titleHtml' | translate"></h1>
    <p class="section-lead center">{{ 'clientes.lead' | translate }}</p>
  </div>

  <div class="filters">
    <div class="buttons-container main">
      <button *ngFor="let m of mains" [class.active]="currentMain === m.key" (click)="selectMain(m.key)">
        {{ m.labelKey | translate }}
      </button>
    </div>
    <div class="buttons-container secondary">
      <button *ngFor="let c of countries" [class.active]="currentCountry === c" (click)="selectCountry(c)">
        {{ countryLabels[c] || c }}
      </button>
    </div>
  </div>

  <div class="logos-grid">
    <div class="logo-card" *ngFor="let l of logos">
      <img [src]="l.img" [alt]="l.alt" loading="lazy">
    </div>
  </div>
</section>

<!-- ===================== TESTIMONIOS ===================== -->
<section class="reviews">
  <div class="rev-head">
    <span class="eyebrow">{{ 'clientes.revEyebrow' | translate }}</span>
    <h2 class="section-title" [innerHTML]="'clientes.revTitleHtml' | translate"></h2>
  </div>

  <ng-container *ngIf="currentReview as r">
    <div class="carousel-reviews">
      <blockquote class="testimonial">
        <p class="company anim-opacity" [class.end]="leaving">{{ r.company }}</p>
        <p class="text anim-opacity" [class.end]="leaving">{{ r.t1 }}</p>
        <p class="text anim-opacity" [class.end]="leaving" *ngIf="r.t2">{{ r.t2 }}</p>
        <p class="text anim-opacity" [class.end]="leaving" *ngIf="r.t3">{{ r.t3 }}</p>
      </blockquote>
    </div>
    <div class="container">
      <img class="anim-scale" [class.end]="leaving" [src]="reviewLogos[revIdx]" [alt]="r.company">
    </div>
  </ng-container>

  <div class="carousel-nav">
    <button (click)="prevReview()" aria-label="Anterior">
      <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="m12.086 4.105.703.704a.38.38 0 0 1 .106.28.514.514 0 0 1-.106.317l-5.45 5.45h11.99c.116 0 .222.046.316.14a.38.38 0 0 1 .105.281v.985a.514.514 0 0 1-.105.316.514.514 0 0 1-.317.106H7.34l5.45 5.449c.07.094.105.199.105.316a.38.38 0 0 1-.106.281l-.703.704a.514.514 0 0 1-.316.105.38.38 0 0 1-.282-.105L4.141 12.05A.334.334 0 0 1 4 11.77c0-.118.047-.211.14-.282l7.348-7.383A.38.38 0 0 1 11.77 4c.117 0 .222.035.316.105Z" fill="currentColor"></path></svg>
    </button>
    <button (click)="nextReview()" aria-label="Siguiente">
      <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="m11.664 4.105-.703.704a.38.38 0 0 0-.106.28c0 .118.036.223.106.317l5.45 5.45H4.42a.437.437 0 0 0-.316.14.38.38 0 0 0-.105.281v.985c0 .117.035.222.105.316.094.07.2.106.317.106H16.41l-5.45 5.449a.514.514 0 0 0-.105.316.38.38 0 0 0 .106.281l.703.704c.094.07.2.105.316.105a.38.38 0 0 0 .282-.105l7.347-7.383a.334.334 0 0 0 .141-.281.334.334 0 0 0-.14-.282l-7.348-7.383A.38.38 0 0 0 11.98 4a.514.514 0 0 0-.316.105Z" fill="currentColor"></path></svg>
    </button>
  </div>
</section>
